<app-layout [isProducerArea]="true">
  <app-page-header
    [title]="'Meus convites'"
    [titleIcon]="'pi pi-gift'"
    [subtitle]="'Gerencie seus convites recebidos.'"
    [breadcrumbs]="[
      { label: 'Início', link: '/', icon: 'pi pi-home' },
      { label: 'Meus convites', icon: 'pi pi-gift' },
    ]"></app-page-header>
  <ng-container>
    <div class="mobile-section-toggle">
      <mat-button-toggle-group [(value)]="displayMobile" [hideSingleSelectionIndicator]="true">
        <mat-button-toggle [value]="DISPLAY_MOBILE_OPTIONS_ENUM.COURTESIES">CORTESIAS</mat-button-toggle>
        <mat-button-toggle [value]="DISPLAY_MOBILE_OPTIONS_ENUM.TRANSFERS">TRANSFERÊNCIAS</mat-button-toggle>
        <mat-button-toggle [value]="DISPLAY_MOBILE_OPTIONS_ENUM.EMPLOYEE">COLABORADOR</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="container-fluid my-invitations p-4">
      @switch (displayMobile) {
        @case (DISPLAY_MOBILE_OPTIONS_ENUM.COURTESIES) {
          <app-events-invitations-tab-page />
        }
        @case (DISPLAY_MOBILE_OPTIONS_ENUM.TRANSFERS) {
          <app-transfer-invitations-tab />
        }
        @case (DISPLAY_MOBILE_OPTIONS_ENUM.EMPLOYEE) {
          <app-collaborator-invitations-tab />
        }
        @default {
          <p>Opção não reconhecida</p>
        }
      }
    </div>
  </ng-container>
</app-layout>
